<template>
    <DadosFinanceirosShared 
        ref="dadosFinanceirosShared"
        :Edicao="Edicao" 
    />
</template>

<script>
import DadosFinanceirosShared from '@/views/Cadastro/Shared/DadosFinanceiros.vue'

export default {
    name: 'CadastroFI_DadosFinanceiros',
    components: { DadosFinanceirosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.dadosFinanceirosShared) {
                return this.$refs.dadosFinanceirosShared.proximaEtapa();
            }
        },
        validarFormulario(submeter) {
            if (this.$refs.dadosFinanceirosShared) {
                return this.$refs.dadosFinanceirosShared.validarFormulario(submeter);
            }
            return true;
        },
        salvarInformacoes() {
            if (this.$refs.dadosFinanceirosShared) {
                return this.$refs.dadosFinanceirosShared.salvarInformacoes();
            }
        }
    }
}
</script>
